<template>
  <v-alert class="transparent ma-0" outline :value="true" :type="type">
    <div class="primary--text">
      <slot />
    </div>
  </v-alert>
</template>

<script>
  export default {
    props: {
      type: String,
    },
  }
</script>